









































import { computed, defineComponent } from '@vue/composition-api';
import ErrorTableColDetail from './error-table-col-detail.vue';
import QuestionTooltip from '@/components/common/question-tooltip/index.vue';

export default defineComponent({
  components: {
    ErrorTableColDetail,
    QuestionTooltip,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    /** 提示文案信息，这里提示信息需要每个一行，因此传一个列表进来 */
    tooltipNames: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const children = computed(() => props.list || []);
    const isAllFail = computed(() => children.value.length === 0);

    return {
      isAllFail,
      children,
    };
  },
});
